import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import FormAutocomplete from '../../../../../shared/FormAutocomplete';
import CustomInputLabel from '../../../../../../layout/styledcomponents/CustomInputLabel';
import moment from 'moment';

const formatTimeWithAmPm = (t?: string) => {
    const raw = String(t ?? '').trim();
    if (!raw) return '';
    const m = moment(
        raw,
        ['H:mm', 'HH:mm', 'h:mm A', 'h:mma', 'hh:mm A'],
        true,
    );
    return m.isValid() ? m.format('h:mm A') : raw;
};

export default function TimeSection({
    control,
    experienceType,
    checkinT,
    checkoutT,
    compareCheckinSettings,
    compareCheckoutSettings,
    checkoutError,
}: any) {
    const checkinLabel = formatTimeWithAmPm(checkinT);
    const checkoutLabel = formatTimeWithAmPm(checkoutT);
    return (
        <>
            <Grid pb='20px'>
                <Box display='flex' gap={0.5} alignItems='center'>
                    <CustomInputLabel required={!checkinT}>
                        {experienceType === 'vehicle'
                            ? 'Expected Pickup Time'
                            : 'Expected Arrival Time'}
                    </CustomInputLabel>
                    <Typography color='textSecondary' fontSize='11px'>
                        (From: {checkinLabel})
                    </Typography>
                </Box>
                <FormAutocomplete
                    name='bookingInfo.checkinTime'
                    control={control}
                    options={compareCheckinSettings}
                />
            </Grid>
            <Grid pb='20px'>
                <Box display='flex' gap={0.5} alignItems='center'>
                    <CustomInputLabel required={!checkoutT}>
                        {experienceType === 'vehicle'
                            ? 'Expected Dropoff Time'
                            : 'Expected Departure Time'}
                    </CustomInputLabel>
                    <Typography color='textSecondary' fontSize='11px'>
                        (Before: {checkoutLabel})
                    </Typography>
                </Box>
                <FormAutocomplete
                    name='bookingInfo.checkoutTime'
                    control={control}
                    options={compareCheckoutSettings}
                    customError={checkoutError}
                />
            </Grid>
        </>
    );
}
